import React, { useState } from 'react'

// Redux
import { useSelector, useDispatch } from "react-redux";
import { setScrapeTopicBrand } from '../../../../store/components/BuildTargets.slice';

// Hooks
import useScrapeKeywords from '../../../../hooks/ScrapedKeywords/useScrapeKeywords';

// Services
import ScrapeServices from '../../../../services/Scrape.services';
import TrackFeatureServices from '../../../../services/TrackFeature.services';
import OneIntelligenceServices from '../../../../services/OneIntelligence.services';

// Helper
import { getCountryCode, getMarketPackageName, getModuleName } from '../../../../utils/oneintelligence/OneIntelligenceHelper';

// Components
import { Button, Progress, Popconfirm } from "antd";
import { CheckCircleFilled, CloseCircleFilled, ArrowLeftOutlined } from "@ant-design/icons";
import { useEffect } from 'react';
import { setSavantReadMessage } from '../../../../store/components/MarketExplorer.slice';

const ScraperProgress = () => {
    const dispatch = useDispatch();
    const [isError, setIsError] = useState(false);
    const [isErrorScraping, setIsErrorScraping] = useState(false);
    const [triggerSavant, setTriggerSavant] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const [statusResponse, setStatusResponse] = useState({});

    const loading = percentage !== 100;

    const { addKeywords } = useScrapeKeywords(false);

    const {
        scrapeTopicBrand
    } = useSelector((state) => state.buildTargets);

    const scrapedStatus = (keywords, callBackStart) => {
        const countryCode = getCountryCode("enterprise");
        const moduleName = getModuleName();
        const marketPackageName = getMarketPackageName();
        return new Promise(async (resolve) => {
            const response = await ScrapeServices.getListKeywordsDetails(keywords, countryCode, marketPackageName, moduleName, callBackStart);
            let { processing, percentage: p } = response.data;
            p = p === 100 ? 90 : p;
            setPercentage(p);
            if (processing.length) {
                setTimeout(() => {
                    resolve(scrapedStatus(keywords, callBackStart));
                }, 3000);
            } else {
                resolve(response.data)
            }
        })
    }

    const runScrape = async () => {
        setPercentage(0);
        setIsError(false);
        setIsErrorScraping(false);
        const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "scrapeTopicStatus" });
        let usedUrl = ""
        const callBackStart = (params, url) => {
            usedUrl = url
            startMonitor(params, { url: usedUrl })
        }
        try {
            const response = await addKeywords(scrapeTopicBrand);
            const { message } = response.data;
            if (message === "Success!") {
                const responseScrape = await scrapedStatus(scrapeTopicBrand, callBackStart);
                const { with_data } = responseScrape
                endMonitor(responseScrape, { url: usedUrl })
                if (with_data.length) {
                    dispatch(setSavantReadMessage(""));
                    setTriggerSavant(true);
                } else {
                    setIsError(true);
                    dispatch(setSavantReadMessage("No Result."));
                    setStatusResponse(responseScrape);
                    setPercentage(100);
                }
            } else throw message
        } catch (error) {
            console.error(error);
            setIsError(true);
            setIsErrorScraping(true);
            dispatch(setSavantReadMessage("No Result."));
        }
    }

    const renderProgress = (
        <>
            <h3 className='oi-title'>Topic/Brand Research In Progress</h3>
            <Progress
                status={"active"}
                percent={percentage}
            />
            <h4 className='oi-description'>
                <p>Please wait...</p>
                <p>{`${percentage.toFixed()}/100`}</p>
            </h4>
        </>
    )

    const renderProgressSuccess = (
        <div className='oi-scraped-progress-success'>
            <CheckCircleFilled className='oi-icon' style={{ color: "#52C41A" }} />
            <p className='oi-percentage'>100/100</p>
            <h3 className='oi-title'>Topic/Brand Research completed</h3>
            <h4 className='oi-description'>You can now use the keyword to target</h4>
        </div>
    )

    const renderProgressError = (
        <div className='oi-scraped-progress-error'>
            <CloseCircleFilled className='oi-icon' style={{ color: "#FF4D4F" }} />
            <h3 className='oi-title'>Topic/Brand Research FAILED</h3>
            {
                statusResponse?.without_data?.length ? <h4 className='oi-description'>{`We couldn't find any results for "${statusResponse?.without_data.join(",")}" topics/brands.`}</h4> : null
            }
            {
                statusResponse?.not_exists?.length ? <h4 className='oi-description'>{`The topics/brands "${statusResponse?.not_exists.join(",")}" you entered doesn't exist.`}</h4> : null
            }
            {
                isErrorScraping ? <Button onClick={() => { runScrape() }}>Retry</Button> : null
            }
        </div>
    )

    useEffect(() => {
        let listsubjects = null;
        if (triggerSavant) {
            let usedUrl = "";
            const region = getCountryCode("savant");
            if (!region) return alert("No savant region");
            const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey: "advanceSavantRead" });

            const callBackGetUrl = (params, url) => {
                usedUrl = url
                startMonitor(params, { url: usedUrl })
            }

            const cancelCallback = () => {
                endMonitor({ message: "Cancel API Call." }, { url: usedUrl })
            }

            const savantReadStatusCallback = (status) => {
                // Savant Status
            };

            const audienceTarget = async () => {
                const keywords = scrapeTopicBrand;
                listsubjects = await OneIntelligenceServices.listSubjects(
                    100,
                    keywords,
                    region,
                    0,
                    savantReadStatusCallback,
                    cancelCallback,
                    callBackGetUrl
                );
                listsubjects.thenpromise
                    .then((resp) => {
                        setTriggerSavant(false);
                        setPercentage(100);
                        if (!resp) {
                            setIsError(true);
                            return;
                        }
                        if (resp.notLoaded) {
                            // Not Loaded
                        } else if (resp.stillLoading) {
                            // Loading
                        } else if (resp.noresult) {
                            setIsError(true);
                            dispatch(setSavantReadMessage("No Result."));
                        } else {
                            const respKeywords = resp.data || resp.response?.data;
                            const resultkeywords = OneIntelligenceServices.filterSavantKeywords(respKeywords);

                            if (resultkeywords.isError) {
                                const errorMsg = resultkeywords.error.replace("Savant:", "").trim();
                                setIsError(true);
                                setStatusResponse({ savant_error: errorMsg });
                                dispatch(setSavantReadMessage(errorMsg));
                            } else {
                                dispatch(setSavantReadMessage(""));
                            }
                        }
                    })
            };
            audienceTarget();
        }
        return () => {
            if (listsubjects) listsubjects.cancel(true);
        };
    }, [triggerSavant]);

    useEffect(() => {
        runScrape();
    }, [])

    const renderContent = () => {
        if (isError) return renderProgressError;
        if (percentage === 100) return renderProgressSuccess;
        else {
            return renderProgress
        }
    }

    return (
        <div className='oi-scraped-progress'>
            {
                loading ? <Popconfirm
                    placement="bottomLeft"
                    title={"Are you sure you want to proceed?"}
                    description={"If you go back, you'll cancel all the progress"}
                    onConfirm={() => {
                        dispatch(setScrapeTopicBrand([]));
                    }}
                    okText="Yes"
                    cancelText="No"
                >
                    <Button type='link' icon={<ArrowLeftOutlined />} disabled={loading} className='oi-back'>Back</Button>
                </Popconfirm> : <Button type='link' icon={<ArrowLeftOutlined />} disabled={loading} className='oi-back' onClick={() => {
                    dispatch(setScrapeTopicBrand([]));
                }}>Back</Button>

            }
            {renderContent()}
        </div>
    )
}

export default ScraperProgress 